import {Box} from "@mui/material";

import ResponsiveAppBar from "../assets/components/ResponsiveAppBar.tsx";
import Footer from "./Footer.tsx";
import PrivacyPolicy from "../assets/components/PrivacyPolicy.tsx";

function Privacy() {
    return (
        <>
            <Box sx={{}}>
                <ResponsiveAppBar/>
                <PrivacyPolicy/>
                <Footer/>
            </Box>
        </>
    );
}

export default Privacy
